import React, { memo, useMemo, useCallback } from 'react';
import { createUseStyles, Tooltip, Icon, Text, useTheme } from '@Sage/hoi-poi-ui';
import classnames from 'classnames';
import { useWeb5Context } from "../../../../../../../../lib/Web5Context";
import { CHART_TYPES, NOT_CHART_TYPES } from "../../../../../../constants";
import styles from "./styles";
const useStyles = createUseStyles(styles, 'ChartSelector');
const ChartSelector = /*#__PURE__*/memo(_ref => {
  let {
    onChange,
    value,
    data,
    label,
    isRequired
  } = _ref;
  const classes = useStyles();
  const {
    t
  } = useWeb5Context();
  const theme = useTheme();
  const pieDisabled = useCallback(() => {
    if (data !== null && data !== void 0 && data.xAxisBreakdown) return true;
    return false;
  }, [data]);
  const chartTypes = useMemo(() => {
    return [{
      id: CHART_TYPES.bar,
      icon: 'verticalBarChartColor',
      label: t('label_bar_chart')
    }, {
      id: CHART_TYPES.hBar,
      icon: 'horizontalBarChartColor',
      label: t('label_horizontal_bar_chart')
    }, {
      id: CHART_TYPES.line,
      icon: 'linesChartColor',
      label: t('label_line_chart')
    }, {
      id: CHART_TYPES.area,
      icon: 'areaChartColor',
      label: t('label_area_chart')
    }, {
      id: CHART_TYPES.pie,
      icon: 'pieChartColor',
      label: t('label_pie_chart'),
      checkDisabled: pieDisabled,
      iconDisabled: 'pieChart',
      labelDisabled: t('label_chart_not_available_with_breakdown')
    }, {
      id: CHART_TYPES.doughnut,
      icon: 'radialBarChartColor',
      label: t('label_doughnut_chart'),
      checkDisabled: pieDisabled,
      iconDisabled: 'radialBarChart',
      labelDisabled: t('label_chart_not_available_with_breakdown')
    }, {
      id: CHART_TYPES.radar,
      icon: 'radarChartColor',
      label: t('label_radar_chart')
    }, {
      id: NOT_CHART_TYPES.kpi,
      icon: 'counterChartColor',
      label: t('label_kpi')
    }, {
      id: NOT_CHART_TYPES.table,
      icon: 'tableChartColor',
      label: t('label_table')
    }
    // Hide until we decide how it has to work
    // {
    //     id: NOT_CHART_TYPES.map,
    //     icon: 'mapChartColor',
    //     label: t('label_map'),
    // },
    ];
  }, [t, pieDisabled]);
  const renderCharts = useMemo(() => {
    return chartTypes.map((current, index) => {
      var _current$checkDisable;
      const isSelected = value === current.id || false;
      const chartClassName = classnames(classes.chartType, {
        [classes.selected]: isSelected
      });
      const isDisabled = (current === null || current === void 0 ? void 0 : (_current$checkDisable = current.checkDisabled) === null || _current$checkDisable === void 0 ? void 0 : _current$checkDisable.call(current)) || false;
      let tooltipContent = current.label;
      let onClick = () => onChange(current.id);
      if (isDisabled) {
        tooltipContent = /*#__PURE__*/React.createElement("div", {
          className: classes.chartTypeTooltipContent
        }, /*#__PURE__*/React.createElement(Text, {
          type: "caption",
          color: theme.colors.primary.white
        }, current.label), /*#__PURE__*/React.createElement(Text, {
          type: "caption",
          color: theme.colors.primary.white
        }, "(", current.labelDisabled, ")"));
        onClick = null;
      }
      return /*#__PURE__*/React.createElement(Tooltip, {
        key: index,
        content: tooltipContent
      }, /*#__PURE__*/React.createElement("div", {
        className: chartClassName,
        key: index,
        onClick: onClick
      }, /*#__PURE__*/React.createElement("div", {
        className: classnames(classes.chartTypeIcon, {
          [classes.chartTypeIconDisabled]: isDisabled
        })
      }, /*#__PURE__*/React.createElement(Icon, {
        size: "large",
        name: isDisabled ? current.iconDisabled : current.icon
      }))));
    });
  }, [chartTypes, classes.chartType, classes.chartTypeIcon, classes.chartTypeIconDisabled, classes.selected, classes.chartTypeTooltipContent, value, onChange, theme]);
  return /*#__PURE__*/React.createElement("div", {
    className: classes.root
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.chartIcons
  }, renderCharts));
});
export default ChartSelector;